import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PartnerSummaryDTO } from 'src/app/models/PartnerSummaryDTO.model';
import { PartnersService } from 'src/app/services/partners.service';
import { SimpleRequestDTO } from 'src/app/shared/models/SimpleRequest';
import { PaginationService } from 'src/app/shared/services/pagination.service';
import { ValidatePermissionsService } from 'src/app/shared/services/validate-permissions.service';

import { FormsModule } from '@angular/forms';
import { ListPartnerStaffComponent } from '../../partner-staff/list-partner-staff/list-partner-staff.component';
import { ListPartnerCustomersComponent } from '../../partner-customers/list-partner-customers/list-partner-customers.component';
import { UserDTO } from '../../../models/UserDTO.model';

@Component({
    selector: 'app-view-partner',
    templateUrl: './view-partner.component.html',
    styleUrls: ['./view-partner.component.css'],
    imports: [FormsModule, ListPartnerStaffComponent, ListPartnerCustomersComponent]
})
export class ViewPartnerComponent {

  currentPartnerId?: number = undefined;
  partnerData?: UserDTO | any;

  request: SimpleRequestDTO = {} as SimpleRequestDTO;
  information: string = '';
  partnerSummary: PartnerSummaryDTO = {} as PartnerSummaryDTO;
  textoBusqueda: string = '';
  filteredCustomers: any[] = [];
  camposBusqueda: string[] = [
    'customerId',
    'customerName',
    'customerEmail',
    'customerPhone',
    'numberPlans'
  ];

  constructor(
    private route: ActivatedRoute,
    private partnerService: PartnersService,
    private router: Router,
    public paginationService: PaginationService,
    public permissionsService: ValidatePermissionsService
  ) {}
  ngOnInit() {
    this.permissionsService.validateAccessLevels(MODULE_ID.Partners);
    this.route.params.subscribe((params) => {
      this.currentPartnerId = params['id'];

      this.partnerService.getListPartners().subscribe(({Data}) =>
      {
        this.partnerData = Data.firstOrDefault(x => x.userId == this.currentPartnerId);
      });

      this.information = 'Partner ID ' + params['id'];
      this.request.id = params['id'];
      this.partnerService.getPartnerSummary(this.request).subscribe(
        ({ StatusCode, Message, Data }) =>
          Data != null
            ? this.handleSaveSuccess(Data)
            : this.handleSaveError(StatusCode),
        (error) => {
          this.clearFields();
        }
      );
    });
  }
  handleSaveSuccess(data: PartnerSummaryDTO) {
    this.partnerSummary = data;
    //console.log(this.partnerSummary);
  }
  handleSaveError(statusCode: number) {}

  clearFields() {}

  goBack() {
    this.router.navigate(['/partners']);
  }

  onSearchChange(): void {
    this.paginationService.currentPage = 1;
    this.filteredCustomers = this.paginationService.updatePagination(
      this.partnerSummary.listCustomers, this.textoBusqueda, this.camposBusqueda
    );
  }

  navigateToCustomerView(customer: any) {

    let partnerID = this.partnerSummary.partnerId;
    this.router.navigate(['/partners/view-partner-customer', customer.customerId],
      { queryParams: { partnerID } }
    )
  }
}
